import getZskkDbInstance from './indexeddb'
const IDBKeyRange = window.IDBKeyRange || window.webkitIDBKeyRange || window.msIDBKeyRange

let instance = null
getZskkDbInstance().then(db => instance = db)
if(instance) {
    console.warn('db init error ! ! !')
}
const getObjectStore = (tableName, permissions) => {
    if(!instance) {
        throw new Error('zskk db instance is null:', instance)
    }
    if(!tableName) {
        throw new Error('tableName is null:', tableName)
    }
    let objectStore
    if(permissions && ['readwrite'].indexOf(permissions) !== -1) {
        objectStore = instance.transaction(tableName, permissions).objectStore(tableName)
    } else {
        objectStore = instance.transaction(tableName).objectStore(tableName)
    }
    if(objectStore) {
        return objectStore
    }
    throw new Error('objectStore is null tableName: ' + tableName + ' permissions:' + permissions)
}

const insert = (tableName, writeObject) => {
    const objectStore = getObjectStore(tableName, 'readwrite')
    const request = objectStore.add(writeObject)
    if(!request) {
        throw new Error('zskk db request is null', request)
    }
    request.onsuccess = function (event) {
        console.log('data write success !')
    };
    request.onerror = function (event) {
        console.warn('data write warn :', event);
    }
}

const query = (tableName, where) => {

}

const queryAll = (tableName, cb) => {
    const logsStore = getObjectStore(tableName)
    const request = logsStore.openCursor()
    if(!request) {
        throw new Error('zskk db request is null', request)
    }
    const req = []
    request.onsuccess = function (event) {
        console.log('zskk db queryAll success data handle ...')
        const cursor = event.target.result;
        if (cursor) {
            req[req.length] = cursor.value
            cursor.continue();
        } else {
            cb(req)
        }
    }
}

const clear = tableName => {
    const objectStore = getObjectStore(tableName, 'readwrite')
    const request = objectStore.clear()
    if(!request) {
        throw new Error('zskk db request is null', request)
    }
    request.onsuccess = event => {
        console.info('zskk db clear success')
    }
    request.onerror = event => {
        console.warn('zskk db clear warn:', event)
    }
}

const count = (tableName,where = null, cb) => {
    // const objectStore = getObjectStore(tableName, 'readonly')
    // const index = objectStore.index('level_index')
    // const request = index.get('warn')
    // const req = []
    // request.onsuccess = function (event) {
    //     console.log('zskk db queryAll success data handle ...')
    //     const cursor = event.target.result;
    //     if (cursor) {
    //         console.log(event)
    //         req[req.length] = cursor.value
    //         cursor.continue();
    //     } else {
    //         cb(req)
    //     }
    // }
    // request.onsuccess = event => {
    //     console.info('zskk count success:', event)
    //     cb(event.target.result)
    // }
    // request.onerror = event => {
    //     console.warn('zskk count warn:', event)
    // }
}

const curl = {insert, queryAll, clear, count}
export default curl